export default "__VITE_ASSET__BYE$llyM__"